import { createActions, createReducer } from 'reduxsauce'

import ConsultaCreditoOrcamentarioReceitasPropriasService from '../../servicos/ConsultaCreditoOrcamentarioReceitasPropriasService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCreditoOrcamentarioReceitasPropriasInicio: [],
    buscaConsultaCreditoOrcamentarioReceitasPropriasErro: ['erro'],
    buscaConsultaCreditoOrcamentarioReceitasPropriasSucesso: ['consultaCreditoOrcamentarioReceitasProprias'],
    limpar: [],
    setConsultaCreditoOrcamentarioReceitasPropriasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaCreditoOrcamentarioReceitasProprias = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCreditoOrcamentarioReceitasPropriasInicio())
        let serv = new ConsultaCreditoOrcamentarioReceitasPropriasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaCreditoOrcamentarioReceitasPropriasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCreditoOrcamentarioReceitasPropriasErro(error)))
    }
}

const buscaConsultaCreditoOrcamentarioReceitasPropriasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCreditoOrcamentarioReceitasPropriasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaCreditoOrcamentarioReceitasPropriasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCreditoOrcamentarioReceitasProprias.resultado,
        dataSincronizacaoDados: action.consultaCreditoOrcamentarioReceitasProprias.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCreditoOrcamentarioReceitasPropriasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS_INICIO]: buscaConsultaCreditoOrcamentarioReceitasPropriasInicio,
    [Types.BUSCA_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS_ERRO]: buscaConsultaCreditoOrcamentarioReceitasPropriasErro,
    [Types.BUSCA_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS_SUCESSO]: buscaConsultaCreditoOrcamentarioReceitasPropriasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CREDITO_ORCAMENTARIO_RECEITAS_PROPRIAS_ESTADO_DT]: setConsultaCreditoOrcamentarioReceitasPropriasEstadoDT,
})
